<template>
  <div class="phone-preview-container">
    <div class="kakao-alimtalk-preview">
      <div class="alimtalk-header">
        알림톡 도착
        <img src="@/assets/img/certificate_settings/alimtalk_kakao.png" />
      </div>
      <div class="alimtalk-title">
        <div class="alimtalk-title-text">
          투명교정기<br />교체하는 날
        </div>
        <div class="alimtalk-title-image">
          <img src="@/assets/img/certificate_settings/clara_logo.png" />
        </div>
      </div>
      <div class="alimtalk-contents">
        <div class="alimtalk-props">
          <div class="alimtalk-prop-wrapper">
            <div class="alimtalk-prop-title">병원명</div>
            <div class="alimtalk-prop-content">스타28치과</div>
          </div>
          <div class="alimtalk-prop-wrapper">
            <div class="alimtalk-prop-title">수술일자</div>
            <div class="alimtalk-prop-content">{{ date }}</div>
          </div>
          <div class="alimtalk-prop-wrapper">
            <div class="alimtalk-prop-title">수술명</div>
            <div class="alimtalk-prop-content">{{ title }}</div>
          </div>
        </div>
        <div class="alimtalk-desc">
          <div class="alimtalk-desc-mass">
            {{ content }}
          </div>
          <div class="alimtalk-desc-mass">
            ▼ 아래 버튼을 클릭하여 받아보세요.
          </div>
        </div>
        <div class="alimtalk-button">
          <button>
            투명교정기 교체방법
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs';

export default {
  props: {
    title: {
      type: String,
    },
    content: {
      type: String,
    },
  },
  computed: {
    date() {
      return dayjs().format('YYYY/MM/DD');
    },
  },
  mounted() {
  },

};
</script>
<style lang="scss" scoped>
  @import '@/assets/scss/issue-certificate.scss';
</style>